export const AUTH_CLIENT_ID = 'any_mob_web_app_interactive_client';

export const CUSTOM_AUTH_TOKEN = import.meta.env.VITE_CUSTOM_AUTH_TOKEN;

export const OPA_POLICIES_NAME = 'conteg';

export const DEFAULT_PAGE_SIZE = 10;

export const UNLIMITED_PAGE_SIZE = 99999;
